export default [
    {
        path: 'distribuicao',
        component: () => import(/* weimunizacaockChunkName: 'imunizacao-distribuicao' */ '@/views/imunizacao/distribuicao/Index'),
        redirect: 'distribuicao/index',
        children: [
            {
                name: 'imunizacao-distribuicao-index',
                path: 'index',
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-distribuicao' */ '@/views/imunizacao/distribuicao/List.vue'),
            },
            {
                name: 'imunizacao-distribuicao-create',
                path: 'create',
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-distribuicao' */ '@/views/imunizacao/distribuicao/Form.vue'),
            },
            {
                name: 'imunizacao-distribuicao-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-distribuicao' */ '@/views/imunizacao/distribuicao/Form.vue'),
            },
        ],
    },
]